/* eslint-disable
    import/default,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import DashboardConstants from 'constants/DashboardConstants'

export default Marty.createStore({
  id: 'DashboardStore',

  getInitialState() {
    return {
      inboxStats: {}
    }
  },

  handlers: {
    fetchInboxMetricsDone: DashboardConstants.INBOX_FETCH_STATS_DONE,
    fetchInboxMetricsFailed: DashboardConstants.INBOX_FETCH_STATS_FAILED
  },

  _cloneStats() {
    return _.cloneDeep(this.state.inboxStats) || {}
  },

  getInboxDateKey(inboxId, startDate, endDate) {
    return `inbox-${ inboxId }-daterange-${ startDate.toString() }-${ endDate.toString() }`
  },

  getOrFetchInboxStats(inboxId, startDate, endDate) {
    return this.fetch({
      dependsOn: [this.app.stores.InboxStore.getOrFetchInboxList()],
      id: `fetchInboxMetrics${ inboxId }`,
      locally() {
        return (this.state.inboxStats != null ? this.state.inboxStats[this.getInboxDateKey(inboxId, startDate, endDate)] : undefined)
      },
        
      remotely() {
        return this.app.queries.InboxQueries.fetchInboxMetrics(inboxId, startDate, endDate)
      }
    })
  },

  fetchInboxMetricsDone(inboxId, startDate, endDate, stats) {
    const inboxStats = this._cloneStats()
    inboxStats[this.getInboxDateKey(inboxId, startDate, endDate)] = stats
    return this.setState({ inboxStats })
  },

  fetchInboxMetricsFailed(stats) { return {} }
})


// WEBPACK FOOTER //
// ./src/scripts/stores/DashboardStore.js